module.exports = __webpack_public_path__ + "img/unilever-icon.e4f8f5bb.svg";